import React, { useEffect, useState} from "react";
import './over-ons.css';
import FrankPic from './componenten/Frank.jpg';
import MarkPic from './componenten/Mark.jpg';
import RubenPic from './componenten/Ruben.jpg';
import GroepsFoto from './componenten/groepsfoto.jpg';

function Overons() {
      useEffect(() => {
    const elements = document.querySelectorAll('.Picture-left, .Picture-right');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.01 });

    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
}, []);
    
    return (
        <div className="OO-Page">
            <div className="OO-Pic">
                <img src={GroepsFoto} alt="Groeps foto" className="Groepsfoto" />
                <div className="overlayfoto">
                    <h1>Wij zijn Mindis</h1>
                </div>
            </div>
                <div className="About">
                    <img src={FrankPic} alt="Picture Frank" className="Picture-left" />
                <div className="Abouttxt">
                    <h2>Frank Manting</h2>
                    <p className="Introtxt"><b>A.K.A. De Creatieve</b> - Werkt op losse papiertjes</p>
                    <p> Frank begon zijn loopbaan als laborant, waar hij proefopstellingen bouwde om van alles te testen. 
                        Toch bleek dingen maken nog leuker dan dingen meten, dus maakte hij de switch naar elektrotechniek. 
                        Inmiddels is hij afgestudeerd als sensortechnoloog en werkt hij aan een slim zitkussen voor mensen met dementie 
                        – technologie met impact dus. </p>
                    <p> Frank is een echte generalist: hij schakelt moeiteloos tussen soldeerbout en storyboard. 
                        Naast het technische werk geeft hij workshops in design thinking en filmt hij technologie van haar beste kant als videograaf. 
                        Altijd met een flinke dosis nieuwsgierigheid én een menselijke blik. </p>
                </div>
            </div>

            <div className="MindisFact">
                De oprichters van Mindis hebben elkaar leren kennen bij Hanze Racing Division
            </div>

            <div className="AboutM">
                    <div className="Abouttxt">
                    <h2>Mark Oosting</h2>
                    <p className="Introtxt" title="Jaja, 100+ WPM"><b>A.K.A. De Techneut</b> - Typt heel erg snel</p>
                    <p>Mark is altijd al met computers bezig geweest: ze uit elkaar halen, 
                        weer in elkaar zetten en erop programmeren. Vanwege zijn drive en passie 
                        voor het vak is hij na de middelbare school in een bijbaantje als webontwikkelaar 
                        gerold. Uiteraard was de opleiding die hij hierbij deed veel te makkelijk, gezien 
                        hij al aan het werk was. Daarom is hij, net als Ruben en Frank, bij Hanze Racing Division 
                        terechtgekomen, waar hij software- en mechanical engineering aan een elektrische raceauto 
                        heeft gedaan. Na een bestuursjaar heeft hij uiteindelijk mechanical engineering afgerond 
                        en is hij weer teruggegaan naar zijn roots: software.</p>
                        <p>Inmiddels werkt Mark onder zijn eigen 
                        ZZP onderneming, onder de naam ‘Easting Solutions’. Hier bouwt hij software en interactieve 
                        (2D/3D) oplossingen. Bij Mindis kan Mark zijn ei kwijt met brainstormen, technisch adviseren 
                        en co-creëren.</p>
                    </div>
                <img src={MarkPic} alt="Picture Mark" className="Picture-right" />
            </div>

            <div className="MindisFact">
                Mindis is ooit begonnen vanuit de E-Motion Chair
            </div>

            <div className="About">
                <img src={RubenPic} alt="Picture Ruben" className="Picture-left"/>
                <div className="Abouttxt">
                    <h2>Ruben Kuiper</h2>
                    <p className="Introtxt"><b>A.K.A. De Regelaar</b> - Heeft alle touwtjes in handen</p>
                    <p>Ruben begon zijn carrière met de opleiding Mechatronica in Apeldoorn, 
                        waar hij ruime ervaring opdeed met elektrotechniek, werktuigbouwkunde 
                        en robotica. Hoewel hij een passie heeft voor techniek, wilde Ruben zich 
                        ook verdiepen in de bedrijfskundige aspecten van organisaties. Daarom 
                        vervolgde hij zijn studie in Groningen met de opleiding Technische Bedrijfskunde, 
                        die hij afrondde met een afstudeeronderzoek naar het productieproces van de E-Motion Chair.</p>
                    <p>Ruben behoudt altijd het overzicht en verliest het einddoel nooit uit het oog. Dankzij 
                        zijn technische expertise én bedrijfskundige vaardigheden slaagt hij erin complexe 
                        technische vraagstukken moeiteloos te vertalen naar heldere, haalbare oplossingen 
                        voor bedrijven en klanten.</p>
                </div>
            </div>
        </div>
    );
}

export default Overons;